import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { LoadingService } from '../shared/loading';
import * as fromRoot from '../store';
import { Store } from '@ngrx/store';
import { tap, map } from 'rxjs/operators';
import { Reminder } from './store/reminder.model';
import { Observable } from 'rxjs';
import { IGenericResponse } from '../shared';
import { ReminderType, ReminderScheduleType } from './store';
import moment from 'moment';
import { IGroup } from '../groups/IGroups';
import { ReminderReviewPeriodModel } from './store/reminder-review-period.model';

@Injectable({
    providedIn: 'root'
})
export class ReminderService extends LoadingService {
    private uri = `${environment.apiLocation}/Reminder`;
    private reminderTypeUri = `${environment.apiLocation}/ReminderType`;
    private reminderScheduleTypeUri = `${environment.apiLocation}/ReminderScheduleType`;
    private reminderRecipientUri = `${environment.apiLocation}/Group`;
    private reminderReviewPeriodUri = `${environment.apiLocation}/ReminderReviewPeriod`;
    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }
    public get(): Observable<Reminder[]> {
        super.Load();
        this.log.verbose({ type: 'ReminderService:get' });
        return this.http.get<Reminder[]>(this.uri).pipe(
            map(items =>
                items.map(item => ({
                    ...item,
                    Scheduletime: moment(item.Scheduletime).toDate()
                }))
            ),
            tap(() => super.Stop())
        );
    }
    public put(reminders: Reminder[]): Observable<IGenericResponse<Reminder>> {
        return this.http
            .put<IGenericResponse<Reminder>>(this.uri, {
                ReminderList: reminders
            })
            .pipe(
                map(resp => ({
                    ...resp,
                    Items: resp.Items.map(item => ({
                        ...item,
                        Scheduletime: moment(item.Scheduletime).toDate()
                    }))
                })),
                tap(resp =>
                    this.log.verbose({ type: 'ReminderService:put', resp })
                )
            );
    }
    public post(Reminderinstanceid: number): Observable<Array<Reminder>> {
        return this.http
            .post<Array<Reminder>>(this.uri, {
                Reminderinstanceid
            })
            .pipe(
                map(items =>
                    items.map(item => ({
                        ...item,
                        Scheduletime: moment(item.Scheduletime).toDate()
                    }))
                ),
                tap(resp =>
                    this.log.verbose({ type: 'ReminderService:post', resp })
                )
            );
    }
    public delete(id: number): Observable<IGenericResponse<Reminder>> {
        return this.http.request<IGenericResponse<Reminder>>(
            'DELETE',
            this.uri,
            {
                body: { EntityIDs: [id] }
            }
        );
        // return this.http.delete<IGenericResponse<Reminder>>(`${this.uri}/${id}`);
    }
    public getReminderTypes(): Observable<ReminderType[]> {
        return this.http.get<ReminderType[]>(this.reminderTypeUri);
    }
    public getReminderScheduleTypes(): Observable<ReminderScheduleType[]> {
        return this.http.get<ReminderScheduleType[]>(
            this.reminderScheduleTypeUri
        );
    }
    public getReminderRecipients(): Observable<IGroup[]> {
        return this.http.post<IGroup[]>(this.reminderRecipientUri, {
            Categoryid: 'REMINDER'
        });
    }
    public getReminderReviewPeriods(): Observable<ReminderReviewPeriodModel[]> {
        return this.http.get<ReminderReviewPeriodModel[]>(
            this.reminderReviewPeriodUri
        );
    }
}
